import checkPartnerAgreementStatus from "@/shared/router/guards/checkPartnerAgreementStatus";

export default {
  default: [
    {
      name: "financeReceivers.table",
      path: "/klanten",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiversTableView.vue"),
      beforeEnter: checkPartnerAgreementStatus
    },
    {
      path: "/klant/:id",
      name: "financeReceivers.view",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiversDetailsView.vue"),
      redirect: { name: "financeReceivers.view.general" },
      beforeEnter: checkPartnerAgreementStatus,
      children: [
        {
          path: "algemeen",
          name: "financeReceivers.view.general",
          component: () => import("@/modules/financeReceivers/views/tabs/GeneralView.vue")
        },
        {
          path: "faciliteit",
          name: "financeReceivers.view.facility",
          component: () => import("@/modules/financeReceivers/views/tabs/FacilityView.vue")
        },
        {
          path: "faciliteit/leningen/:loanId",
          name: "financeReceivers.view.facility.loan",
          components: {
            default: () => import("@/modules/financeReceivers/views/tabs/FacilityView.vue"),
            sideBar: () => import("@/modules/loans/views/LoanDetailPanelView.vue")
          }
        }
      ]
    }
  ]
};
